import { useAnchorWallet } from "@solana/wallet-adapter-react";
import React, { FC, useState } from "react";
import { MESSAGE_TYPE } from "../../../../../../../common/constants/common.constants";
import { IClubDataForProposal } from "../../../../../../../common/interfaces/clubs.interface";
import { IProposalWithMetaData } from "../../../../../../../common/interfaces/proposals.interface";
import { dashboardStore } from "../../../../../../../contexts/dashboardStore";
import { proposalsStore } from "../../../../../../../contexts/proposalContext";
import { getSingleWithdrawalAccount } from "../../../../../../../solana/common/helpers/withdrawal.helpers";
import { claimWithdrawalAmount } from "../../../../../../../solana/methods/proposals";
import { createNotification } from "../../../../../../../utilities/notification";
import SubmitButton from "../../../../../../SubmitButton/SubmitButton";
import { clubsStore } from "../../../../../../../contexts/clubStore";

const ClaimButton: FC<{
  proposalWithMetaData: IProposalWithMetaData;
  clubBasicInfo: IClubDataForProposal;
}> = ({ proposalWithMetaData, clubBasicInfo }) => {
  const updateProposal = proposalsStore((state) => state.updateProposal);
  const { withdrawals, setWithdrawals } = dashboardStore();
  const { setWithdrawalMembersInfo, withdrawalMembersInfo } = clubsStore();

  const [isClaiming, toggleClaiming] = useState(false);

  const wallet = useAnchorWallet();

  const claimWitdrawalProposal = async () => {
    try {
      toggleClaiming(true);
      await claimWithdrawalAmount(
        wallet!,
        proposalWithMetaData?.metadata.withdrawal,
        proposalWithMetaData?.metadata.withdrawalData,
        clubBasicInfo.clubName
      );
      const { memberWithdrawalData: updatedWithdrawalAccount } =
        await getSingleWithdrawalAccount(
          clubBasicInfo.clubName,
          proposalWithMetaData!.proposalBasicData.proposalAccount.pubkey,
          clubBasicInfo.treasury,
          wallet!,
          proposalWithMetaData!.metadata.withdrawalAmount,
          clubBasicInfo.memberRights,
          proposalWithMetaData!.metadata.withdrawalMint,
          proposalWithMetaData!.metadata.mintDecimals,
          proposalWithMetaData!.metadata.mintSymbol,
          clubBasicInfo.denominatedTokenInfo,
          proposalWithMetaData.proposalBasicData.proposalMetadata
            .currentFundraiseIndex,
          proposalWithMetaData.proposalBasicData.proposalMetadata.createdAt,
          clubBasicInfo.reservedRights
        );
      if (!clubBasicInfo.isDashboardProposal && updatedWithdrawalAccount) {
        const addedWithdrawalMembersInfos = [...(withdrawalMembersInfo ?? [])];
        const foundMemberInfoIndex = addedWithdrawalMembersInfos.findIndex(
          (info) =>
            info.proposal.toString() ===
            proposalWithMetaData!.proposalBasicData!.proposalAccount.pubkey.toString()
        );

        addedWithdrawalMembersInfos[foundMemberInfoIndex] = {
          ...updatedWithdrawalAccount,
        };
        setWithdrawalMembersInfo(addedWithdrawalMembersInfos);
      }
      if (clubBasicInfo.isDashboardProposal && updatedWithdrawalAccount) {
        const addedWithdrawals = [...withdrawals!];
        const withdrawalIndex = addedWithdrawals.findIndex(
          (withdrawal) =>
            withdrawal.withdrawal.toString() ===
            updatedWithdrawalAccount.withdrawal.toString()
        );
        addedWithdrawals[withdrawalIndex] = {
          ...addedWithdrawals[withdrawalIndex],
          hasWithdrawn: true,
        };
        setWithdrawals(addedWithdrawals);
        proposalWithMetaData!.metadata.withdrawalMembersInfo.hasUserClaimed =
          true;
      }

      const newMetadata = {
        ...proposalWithMetaData?.metadata,
        withdrawalMembersInfo: {
          ...updatedWithdrawalAccount,
          hasUserClaimed: true,
        },
      };
      const existingProposal = {
        ...proposalWithMetaData!,
        metadata: newMetadata,
      };
      updateProposal(existingProposal);
      toggleClaiming(false);
      createNotification(MESSAGE_TYPE.SUCCESS, "Funds successfully claimed");
    } catch (error: any) {
      createNotification(MESSAGE_TYPE.ERROR, error.message);
      toggleClaiming(false);
    }
  };
  return (
    <SubmitButton
      className="proposals-item-actions__form-button"
      onClick={claimWitdrawalProposal}
      submitting={isClaiming}
    >
      Claim
    </SubmitButton>
  );
};

export default ClaimButton;
